import { useNavigate } from "react-router-dom";
import { TriageBadge, ageFromDob } from "@/lib/clinical";

export default function PatientGrid({ patients, loading }) {
  const navigate = useNavigate();

  if (loading) {
    return <div className="py-20 text-center text-slate-400 text-sm">Loading patients…</div>;
  }
  if (patients.length === 0) {
    return (
      <div className="py-20 text-center bg-white rounded-xl border border-dashed border-slate-300" data-testid="no-patients-message">
        <p className="font-heading font-bold text-[#0F2547] text-lg mb-1">No patients found</p>
        <p className="text-sm text-slate-500">Add your first patient to start recording observations.</p>
      </div>
    );
  }
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
      {patients.map((p) => (
        <button
          key={p.id}
          data-testid={`patient-card-${p.id}`}
          onClick={() => navigate(`/patients/${p.id}`)}
          className="patient-card text-left bg-white rounded-xl border border-slate-200 p-5 hover:border-[#005EB8] hover:shadow-md transition-all group"
        >
          <div className="flex items-start justify-between gap-2 mb-2">
            <div>
              <p className="font-heading font-bold text-[#0F2547] text-lg leading-tight group-hover:text-[#005EB8] transition-colors">
                {p.first_name} {p.last_name}
              </p>
              <p className="text-xs text-slate-500">
                {p.dob ? `DOB ${p.dob}${ageFromDob(p.dob) != null ? ` (${ageFromDob(p.dob)}y)` : ""}` : "DOB not recorded"}
              </p>
            </div>
            {p.status === "discharged" ? (
              <span className="inline-flex items-center px-2.5 py-1 rounded-full text-[11px] font-bold border bg-slate-100 text-slate-500 border-slate-200">Discharged</span>
            ) : (
              <TriageBadge triage={p.triage} />
            )}
          </div>
          {p.allergies?.length > 0 && (
            <p className="text-xs font-semibold text-[#D5281B] mb-2">Allergies: {p.allergies.join(", ")}</p>
          )}
          <p className="text-[11px] text-slate-500 mb-1" data-testid={`patient-lead-${p.id}`}>
            Lead: <span className="font-semibold text-[#0F2547]">{p.created_by_name || "—"}</span>
            {p.last_treated_by_name && p.last_treated_by_name !== p.created_by_name && (
              <> · Last treated by <span className="font-semibold text-[#0F2547]">{p.last_treated_by_name}</span></>
            )}
          </p>
          <div className="flex items-center justify-between text-xs text-slate-500 mt-3 pt-3 border-t border-slate-100">
            <span className="truncate mr-2">{p.event_location || "No event recorded"}{p.venue ? ` · ${p.venue}` : ""}</span>
            <span className="shrink-0">
              {p.last_observation_at ? `Last obs ${new Date(p.last_observation_at).toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })}` : "No obs yet"}
            </span>
          </div>
        </button>
      ))}
    </div>
  );
}
